import { Injectable } from '@angular/core';
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { NotificationUtil } from '../../shared/util/notification.util';
import { Constant } from '../../shared/common/constant';
import { ErrorResponse } from '../../shared/model/local/error/error-response';
import { Params } from '@angular/router';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(
    private notificationUtil: NotificationUtil
  ) {}

  public intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((error: any) => {
        if (error instanceof HttpErrorResponse) {
          const { status } = error;

          if (request.headers.has(Constant.HTTP_IGNORE_ERROR)) {
            return throwError({
              handled: false,
              error: error.error,
              customErrorCode: false,
            } as ErrorResponse);
          }

          if (status === 403) {
            this.showMessage('ERROR.FORBIDDEN');
            return throwError({
              handled: true,
              error: error?.error,
            } as ErrorResponse);
          } else if (status === 401) {
            return throwError({
              handled: true,
              error: error?.error,
            } as ErrorResponse);
          } else if (
            [400, 422].includes(status) &&
            (error.error?.errorCode || error.error?.errorDescription)
          ) {
            const { errorCode, errorDescription } = error.error;
            const customHandleErrorCodes =
              request.headers.getAll(Constant.HTTP_CUSTOM_HANDLE_ERROR_CODES) ||
              [];

            if (customHandleErrorCodes.includes(errorCode)) {
              return throwError({
                handled: false,
                error: error.error,
                customErrorCode: true,
              } as ErrorResponse);
            }

            if (errorDescription) {
              this.showMessage(errorDescription, { errorCode });
            } else {
              this.showMessage('ERROR.GENERAL_ERROR', { errorCode });
            }

            return throwError({
              handled: true,
              error: error.error,
            } as ErrorResponse);
          } else {
            this.showMessage('ERROR.GENERAL_ERROR');
          }
        }

        return throwError({
          handled: true,
          error: error.error,
        } as ErrorResponse);
      })
    );
  }

  private showMessage(key: string, params: Params = {}) {
    this.notificationUtil.error(key, params);
  }
}
